import React from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import logoBilad from "../assets/images/logo-bilad.svg";

function TapeLabel({ components = [], avoidImage = false }) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <div
          className={`tape-label${setAdditionalClasses(
            ["width-80", "background-secondary", "single-border"],
            [avoidImage, avoidImage, avoidImage]
          )}`}
          style={getVisibleSensorAnimation(
            isVisible,
            `${
              generalSettings.rtlLanguage
                ? avoidImage
                  ? "width-increase-flipped"
                  : "width-increase"
                : avoidImage
                ? "width-increase"
                : "width-increase-flipped"
            } 1s backwards`
          )}
        >
          {!avoidImage && (
            <img src={logoBilad} alt="" className="tape-label__logo" />
          )}
          {components.map((component, index) => (
            <VisibilitySensor partialVisibility>
              {({ isVisible }) => (
                <div
                  key={index}
                  style={getVisibleSensorAnimation(
                    isVisible,
                    `fadeIn 1s ${1 + index * 0.25}s backwards`
                  )}
                  className={`tab-label__component${setAdditionalClasses(
                    ["only-text"],
                    [avoidImage]
                  )}`}
                >
                  {component}
                </div>
              )}
            </VisibilitySensor>
          ))}
        </div>
      )}
    </VisibilitySensor>
  );
}

export default TapeLabel;
